/* Ella 6.7.6 — AJAX quick-add for dedicated recommendation column.
   Uses the theme's existing sharedFunctions.updateSidebarCart(cart).
   Does not rewrite the theme's cart events, discounts, or checkout logic. */
(() => {
  'use strict';

  const init = () => {
    const drawer = document.getElementById('halo-cart-sidebar');
    if (!drawer || !drawer.classList.contains('ella-cart-rec--enabled')) return;

    const panel = drawer.querySelector('[data-ella-cart-recommendations]');
    const empty = drawer.querySelector('[data-ella-rec-empty]');
    if (!panel || !empty) return;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const cartUrl = root + 'cart.js';
    const addUrl = root + 'cart/add.js';
    let refreshTimer = null;

    function updateSuggestions(cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      const productIds = new Set(cart.items.map((item) => String(item.product_id)));
      let shown = 0;
      panel.querySelectorAll('[data-ella-product-id]').forEach((card) => {
        const canShow = !productIds.has(card.getAttribute('data-ella-product-id')) && shown < 6;
        card.hidden = !canShow;
        if (canShow) shown += 1;
      });
      empty.hidden = shown !== 0;
    }

    async function readCart() {
      const response = await fetch(cartUrl, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
      if (!response.ok) throw new Error('Could not refresh cart');
      return response.json();
    }

    function scheduleSuggestionsRefresh() {
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(async () => {
        try { updateSuggestions(await readCart()); } catch (error) { console.warn('[Ella Cart Recommendations]', error); }
      }, 250);
    }

    // When a different product is added/removed through the native Ella cart,
    // the cart counter changes and the recommendation list is resynchronized.
    const counter = drawer.querySelector('[data-cart-count]');
    if (counter) {
      new MutationObserver(scheduleSuggestionsRefresh).observe(counter, { childList: true, characterData: true, subtree: true });
    }
    new MutationObserver(() => {
      if (document.body.classList.contains('cart-sidebar-show')) scheduleSuggestionsRefresh();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    drawer.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-ella-cart-rec-add]');
      if (!form || !panel.contains(form)) return;
      event.preventDefault();
      event.stopPropagation();

      const button = form.querySelector('button[type="submit"]');
      const feedback = form.parentElement.querySelector('.ella-cart-rec__feedback');
      const variantId = Number(form.querySelector('[name="id"]')?.value);
      if (!Number.isSafeInteger(variantId) || variantId <= 0) return;
      if (button.disabled) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (feedback) feedback.textContent = '';
      try {
        const response = await fetch(addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok) {
          throw new Error(result.description || result.message || 'Unable to add this product.');
        }
        const cart = await readCart();
        updateSuggestions(cart);
        if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
          // This is the same integration point used in the supplied
          // halo-toolcart.js coupon implementation.
          window.sharedFunctions.updateSidebarCart(cart);
        } else {
          // Fail safely: never leave the cart UI stale after a successful add.
          window.location.reload();
        }
      } catch (error) {
        if (feedback) feedback.textContent = error.message || 'Unable to add this product. Please try again.';
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }, true);

    scheduleSuggestionsRefresh();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
